<template lang="pug">
div
  BrPassportForm

div(v-if="formComplete" id="detailsRef")
  BrPassportDetails
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia"

import { usePassport } from "@/store"
import BrPassportForm from "@/components/result/br-passport/BrPassportForm.vue"
import BrPassportDetails from "@/components/result/br-passport/BrPassportDetails.vue"

const { formComplete } = storeToRefs(usePassport())

</script>
